import React from 'react';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  onBack?: () => void;
  rightContent?: React.ReactNode;
  className?: string;
  containerRef?: React.Ref<HTMLDivElement>;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, onBack, rightContent, className = '', containerRef }) => {
  return (
    <div
      ref={containerRef}
      className={`fixed top-0 left-0 right-0 z-50 bg-black/20 backdrop-blur-md border-b border-white/10 ${className}`}
    >
      <div className="flex items-center justify-between px-4 py-2">
        {onBack ? (
          <button
            onClick={onBack}
            className="group flex items-center justify-center w-9 h-9 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white hover:bg-white/20 hover:border-white/30 transition-all duration-300 hover:scale-105"
            aria-label="返回"
          >
            <svg
              className="w-4 h-4 transition-transform duration-300 group-hover:-translate-x-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        ) : (
          <div className="w-9 h-9" />
        )}

        <div className="flex-1 text-center">
          <h1 className="text-lg font-semibold text-white">{title}</h1>
          {subtitle && <div className="text-xs text-white/60">{subtitle}</div>}
        </div>

        <div className="flex items-center gap-2">{rightContent || <div className="w-9 h-9" />}</div>
      </div>
    </div>
  );
};

export default PageHeader;
